/**
 * 태스크 패널 주소 — 지금 보던 화면(보기 탭 포함)에 ?task=<id> 만 붙인다 (Task Flows 1a · Task panel).
 * 패널은 TaskWorkspace 가 띄우고, "Open full page" 로 상세 페이지에 간다.
 */
export const panelTo = (location, taskId) => {
  const params = new URLSearchParams(location.search);
  params.set('task', taskId);
  return { pathname: location.pathname, search: `?${params.toString()}` };
};
